import { useEffect, useState } from 'react';

import routes from 'js/core_pre_webpack/routes';

import { SidebarData } from './types';

export const useSidebarData = (work_id: number) => {
  const [sidebarData, setSidebarData] = useState<SidebarData | null>(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const opts = {
      subdomain_param: 'api',
      work_id,
      referring_hit_id: window.Aedu.hit_data?.id,
    };

    fetch(routes.api_v0_work_liswp_sidebar_url(opts), {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then(setSidebarData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [work_id]);

  return { sidebarData, error, loading };
};
